import type { AppRole } from "./navigation";

export function canManageObjectStructure(role: AppRole): boolean {
	return role !== "manager";
}

export function canEditRoomPrice(role: AppRole): boolean {
	return role !== "manager";
}

export function canSellRoom(role: AppRole): boolean {
	return role !== "super";
}

export function canCreateSale(role: AppRole): boolean {
	return role !== "super";
}

export function canGiveDiscount(role: AppRole): boolean {
	return role === "manager";
}

export function canCreateClient(role: AppRole): boolean {
	return role !== "super";
}

export function canCreateLead(role: AppRole): boolean {
	return role !== "super";
}

export function canCancelSale(role: AppRole): boolean {
	return role === "admin";
}

export function canDeleteSale(role: AppRole): boolean {
	return role === "admin";
}

export function canUseEarlyPayment(role: AppRole): boolean {
	return role !== "super";
}

export function canManagePaymentSchedule(role: AppRole): boolean {
	return role === "admin";
}

export function canManagePaymentSettings(role: AppRole): boolean {
	return role === "admin" || role === "super";
}

export function canManageUsers(role: AppRole): boolean {
	return role === "admin" || role === "super";
}

export function canSendManualSms(role: AppRole): boolean {
	return role === "admin" || role === "manager";
}

export function canManageLeadStatuses(role: AppRole): boolean {
	return role === "admin";
}

export function canTopupSmsBalance(role: AppRole): boolean {
	return role === "admin";
}
